import { useBreakpoint } from '@palmetto/dsm-components';
import { useEffect, useState } from 'react';
import { useTranslation } from '../../providers/TranslationProvider/TranslationProvider';
import { trackEvent } from '../../tracking/Tracking';
import { Button } from '../Button/Button';
import { ModalV3 } from '../ModalV3/ModalV3';

export interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoUrls: { desktop: string; mobile: string };
  trackingId: string;
}

export const VideoModal = ({ isOpen, onClose, videoUrls, trackingId }: VideoModalProps) => {
  const { t } = useTranslation();
  const [hasPlayed, setHasPlayed] = useState(false);
  const [hasWatched, setHasWatched] = useState(false);
  const { currentBreakpoint } = useBreakpoint();
  const isMobile = currentBreakpoint === 'xs' || currentBreakpoint === 'sm';

  useEffect(() => {
    if (!isOpen) {
      setHasPlayed(false);
      setHasWatched(false);
    }
  }, [isOpen]);

  const handlePlay = () => {
    if (!hasPlayed) {
      setHasPlayed(true);
      trackEvent('video played', { trackingId });
    }
  };

  const handleEnded = () => {
    if (!hasWatched) {
      setHasWatched(true);
      trackEvent('video watched', { trackingId });
    }
  };

  return (
    <ModalV3 open={isOpen} onClose={onClose} trackingId={trackingId} showCloseButton>
      {isOpen && (
        <div className="flex flex-col gap-16">
          <video
            src={isMobile ? videoUrls.mobile : videoUrls.desktop}
            className="w-full rounded-16 bg-black object-contain"
            controls
            playsInline
            autoPlay
            onPlay={handlePlay}
            onEnded={handleEnded}
          />
          <div className="flex justify-end">
            <Button
              trackingId={`${trackingId}-done-button`}
              onClick={onClose}
              emphasis="primary"
              layout="hug"
            >
              {t('common.done')}
            </Button>
          </div>
        </div>
      )}
    </ModalV3>
  );
};
